module.exports = __webpack_public_path__ + "static/media/info.dd17c63a.svg";